
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import sincronizar from './resumen-menu-procesos-sincronizar.vue';
    import duplicar from './resumen-menu-procesos-duplicar.vue';
    import abrir from './resumen-menu-procesos-abrir.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            sincronizar,
            abrir,
            duplicar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }
    }
